import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router } from '@angular/router';
import { get, isNil, keys, intersection } from 'lodash';
import { filter, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivateChild {
  private _previousRoute: ActivatedRouteSnapshot = new ActivatedRouteSnapshot();

  constructor(public authService: AuthService, private router: Router) {}

  canActivateChild(route: ActivatedRouteSnapshot) {
    const routePermissions = get(route, 'data.permissionCodes');

    if (isNil(routePermissions) || routePermissions.length <= 0) {
      return true;
    }

    return this.authService.permissionLoadComplete$.asObservable().pipe(
      filter((a) => a === true),
      map(() => {
        const userPermissions = keys(this.authService.permissions);
        const result = intersection(userPermissions, routePermissions);

        if (result.length > 0) {
          this._previousRoute = route;
          return true;
        }

        if (isNil(this._previousRoute)) {
          this._previousRoute = route;
          return false;
        }

        const previousUrl = this._previousRoute.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/');

        const nextUrl = route.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/');

        this._previousRoute = route;

        if (previousUrl === nextUrl) {
          this.router.navigateByUrl('/instrumententafel');
        }

        return false;
      })
    );
  }
}
